module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.3@core-js/library/modules/_library.js
// module id = 84
// module chunks = 0